export const SSO_ACCOUNTS_TABS = {
    RAW_DATA: 'raw-data',
    STATISTIC: 'statistic',
} as const;

export const getSsoAccountsActiveTab = (searchParams: URLSearchParams) => (
    searchParams.get('tab') === SSO_ACCOUNTS_TABS.STATISTIC
        ? SSO_ACCOUNTS_TABS.STATISTIC
        : SSO_ACCOUNTS_TABS.RAW_DATA
);

export const getSsoAccountsTabSearchParams = (searchParams: URLSearchParams, tab: string) => {
    const nextSearchParams = new URLSearchParams(searchParams);

    if (tab === SSO_ACCOUNTS_TABS.STATISTIC) {
        nextSearchParams.set('tab', SSO_ACCOUNTS_TABS.STATISTIC);
    } else {
        nextSearchParams.delete('tab');
    }

    return nextSearchParams;
};
